import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { AppDispatch, RootState } from 'store'
import { invoicesApi } from 'store/invoices/invoices.api'
import type { PodOrderInfo } from 'pages/invoice/invoice.utils'

export function usePodPresenceForOrders(
  orderIds: string[]
): Record<string, PodOrderInfo> {
  const dispatch = useDispatch<AppDispatch>()
  const idsKey = useMemo(() => {
    const unique = Array.from(
      new Set(orderIds.filter((id): id is string => Boolean(id)))
    )
    unique.sort()
    return unique.join('|')
  }, [orderIds])
  const uniqueIds = useMemo(
    () => (idsKey ? idsKey.split('|') : []),
    [idsKey]
  )

  useEffect(() => {
    const subscriptions = uniqueIds.map((orderId) =>
      dispatch(invoicesApi.endpoints.listInvoicedocuments.initiate({ orderId }))
    )
    return () => {
      subscriptions.forEach((sub) => sub.unsubscribe())
    }
  }, [dispatch, uniqueIds])

  return useSelector((state: RootState) => {
    const out: Record<string, PodOrderInfo> = {}
    for (const orderId of uniqueIds) {
      const q = invoicesApi.endpoints.listInvoicedocuments.select({ orderId })(
        state
      )
      if (q.isSuccess && q.data) {
        out[orderId] = {
          resolved: true,
          hasPod: (q.data.POD?.length ?? 0) > 0,
        }
      } else {
        out[orderId] = { resolved: false, hasPod: false }
      }
    }
    return out
  })
}
